import { render, staticRenderFns } from "./GroupMembers.vue?vue&type=template&id=47f16962&scoped=true"
import script from "./GroupMembers.vue?vue&type=script&lang=ts"
export * from "./GroupMembers.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "47f16962",
  null
  
)

export default component.exports